import React from 'react';

import { LANDING_PAGE_SECTIONS_NAMES } from 'Utilities/analytics';
import { useFeatureFlags } from 'Utilities/hooks';

import prizeCardAVIF from '../../../../../../../client/assets_seller/landingpages/car_prize_draw/prize-card.avif';
import prizeCardPNG from '../../../../../../../client/assets_seller/landingpages/car_prize_draw/prize-card.png';
import prizeCardWEBP from '../../../../../../../client/assets_seller/landingpages/car_prize_draw/prize-card.webp';
import { usePageRefEvents } from '../../../../common/Hooks/usePageRefEvents';
import { carPrizeDrawSectionLoadEvent } from '../CarPrizeDraw.helpers';

import texts from './PrizeSection.texts.json';

import styles from './PrizeSection.module.scss';

export const PrizeSection: React.FC = () => {
  const { showCarPrizeDraw } = useFeatureFlags();
  const Texts = showCarPrizeDraw ? texts.open : texts.closed;

  const onRefTrigger = () => carPrizeDrawSectionLoadEvent(LANDING_PAGE_SECTIONS_NAMES.PRIZE);

  const { setRef } = usePageRefEvents({ onRefTrigger });

  return (
    <div ref={(ref) => setRef(ref)} className={styles.component} data-testid="prizeSection">
      <div className={styles.card}>
        <div className={styles.imageWrapper}>
          <picture>
            <source srcSet={prizeCardAVIF} type="image/avif" />
            <source srcSet={prizeCardWEBP} type="image/webp" />
            <img alt={texts.imageAlt} src={prizeCardPNG} />
          </picture>
        </div>
        <div className={styles.content}>
          <h2 className={styles.title}>{Texts.title}</h2>
          <div className={styles.description}>
            {Texts.paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
